export default {
      id: "menu__fuel_cards-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.svg#menu__fuel_cards",
      toString: function () {
        return this.url;
      }
    }